// extracted by mini-css-extract-plugin
export var content = "_mr-1";
export var fullScreen = "_mr-0";